const styles = theme => {
  return {
    dialogContent: {
      display: 'flex',
      height: '80vh',
      width: '90vw',
      overflow: 'auto'
    },
    title: {},
    table: {
      width: '100%'
    },
    labelCell: {
      fontWeight: 600,
      whiteSpace: 'nowrap',
      verticalAlign: 'top'
    },
    valueCell: {
      wordBreak: 'break-word'
    },
    actionIcon: {
      margin: '5px 10px',
      cursor: 'pointer',
      fontSize: '18px',
      '&:hover': { filter: 'brightness(1.5)' }
    },
    actionCell: {
      display: 'flex'
    }
  };
};

export default styles;
